import { render, staticRenderFns } from "./ProductsCarouselSegment.vue?vue&type=template&id=6f7d1ba3&"
import script from "./ProductsCarouselSegment.vue?vue&type=script&lang=js&"
export * from "./ProductsCarouselSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports